var render = function (_h,_vm) {var _c=_vm._c;return _c('span',_vm._g(_vm._b({ref:_vm.data.ref,class:[
    'jz-filter-button',
    _vm.data.class,
    _vm.data.staticClass
  ],style:([_vm.data.style, _vm.data.staticStyle])},'span',_vm.data.attrs,false),_vm.listeners),[_vm._t("default"),_c('span',{staticClass:"category-count"},[_vm._v("("+_vm._s(_vm.props.count)+")")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }